var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewIdeaIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 50,
    viewBox: "0 0 39 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "fill-background",
    d: "M15.8206 50.0001C18.141 50.0001 20.0394 48.1016 20.0394 45.7812H11.6018C11.6018 48.1016 13.5003 50.0001 15.8206 50.0001Z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "fill-background",
    d: "M9.49238 43.6717H22.1489C23.3091 43.6717 24.2583 42.7225 24.2583 41.5623C24.2583 40.4021 23.3091 39.4529 22.1489 39.4529H9.49238C8.3322 39.4529 7.38297 40.4021 7.38297 41.5623C7.38297 42.7225 8.3322 43.6717 9.49238 43.6717Z",
    fill: "#000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "fill-background",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.8461 9.99761V12.0809L15.0007 12.0808C14.2053 12.0808 13.5605 12.7256 13.5605 13.521C13.5605 14.3163 14.2053 14.9611 15.0007 14.9611H23.8461V23.8065C23.8461 24.6019 24.4908 25.2466 25.2862 25.2466C26.0816 25.2466 26.7263 24.6019 26.7263 23.8065L26.7263 14.9611H29.053C30.6892 17.4518 31.6413 20.4315 31.6413 23.6323C31.6413 31.6902 26.0302 35.9935 23.6888 37.3435H7.9525C5.61105 35.9935 0 31.6902 0 23.6323C0 14.8993 7.08764 7.81165 15.8206 7.81165C18.7492 7.81165 21.4928 8.60872 23.8461 9.99761Z",
    fill: "#000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "stroke-background",
    d: "M27.7263 3.44012C27.7263 2.09248 26.6339 1 25.2862 1C23.9386 1 22.8461 2.09248 22.8461 3.44012L22.8461 11.0809L15.0007 11.0808C13.653 11.0808 12.5605 12.1733 12.5605 13.521C12.5605 14.8686 13.653 15.9611 15.0007 15.9611H22.8461L22.8461 23.8065C22.8461 25.1542 23.9386 26.2466 25.2862 26.2466C26.6339 26.2466 27.7263 25.1542 27.7263 23.8065L27.7263 15.9611H35.3671C36.7147 15.9611 37.8072 14.8686 37.8072 13.521C37.8072 12.1733 36.7147 11.0809 35.3671 11.0809L27.7263 11.0809L27.7263 3.44012Z",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewIdeaIcon);
export default __webpack_public_path__ + "static/media/newIdeaIcon.fe9e3391.svg";
export { ForwardRef as ReactComponent };